const SUBMISSION_STATUS_LABELS = {
  pending: 'Pending',
  succeeded: 'Succeeded',
  failed: 'Failed',
};

export default function getSubmissionStatusLabel(status) {
  return SUBMISSION_STATUS_LABELS[status] || 'Unknown';
}
